import { selectedAdAccountIdVar } from '../../constants';
import { getGraphQLErrorHttpStatus } from './getGraphQLErrorHttpStatus';

export const clearSelectedAdAccountIfNotFoundForStatus = (status: number | undefined, adAccountId: string): void => {
  if (status === 404 && selectedAdAccountIdVar() === adAccountId) {
    selectedAdAccountIdVar(undefined);
  }
};

export const clearSelectedAdAccountIfNotFound = (error: unknown, adAccountId: string): void => {
  clearSelectedAdAccountIfNotFoundForStatus(getGraphQLErrorHttpStatus(error), adAccountId);
};
